/* eslint-disable jsdoc/require-jsdoc */
export async function wait(ms: number) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}
